<template lang="pug">
.manage-work-agent-page
  v-card.pa-4
    .d-flex.align-center.justify-space-between.mb-3
      .text-h6 Manage Work Agent Definition
      v-btn(color="#14C6DE" dark depressed :loading="loadingList" @click="fetchList") Refresh

    .table-wrap
      table.table
        thead
          tr
            th.guid-col GUID
            th.name-col Agent Name
            th.description-col Description
            th.config-col Agent config
        tbody
          tr(
            v-for="row in rows"
            :key="row.id"
            :class="{ selected: String(row.id)===String(selectedId) }"
            @click="selectRow(row)"
          )
            td.guid-col {{ row.id }}
            td.name-col {{ row.agent_name }}
            td.description-col.ellipsis {{ row.goal }}
            td.config-col.ellipsis {{ row.agent_config }}

    v-divider.my-4

    .form-grid
      .form-row
        .label GUID
        v-text-field(v-model="form.guid" dense outlined hide-details placeholder="未填寫視同新增")

      .form-row
        .label Agent Name
        v-text-field(v-model="form.agent_name" dense outlined hide-details)

      .form-row
        .label Description
        v-text-field(v-model="form.goal" dense outlined hide-details)

      .form-row
        .label Agent config
        v-textarea(v-model="form.agent_config_text" dense outlined hide-details rows="15")

    .d-flex.justify-start.mt-4
      v-btn.mr-2(color="#14C6DE" dark depressed height="40" :loading="saving" :disabled="saving" @click="onUpdate") 儲存
      v-btn.mr-2(outlined height="40" :disabled="saving" @click="onCancelEdit") 取消
      v-btn.mr-2(color="error" depressed height="40" :disabled="saving || !selectedId" :loading="deleting" @click="onDelete") 刪除
      v-btn(v-if="isAdmin" outlined height="40" :disabled="!selectedId" @click="onManageAccess") {{ $t('WORK_AGENT.MANAGE_ACCESS') }}

  v-dialog(v-model="dialog" max-width="420")
    v-card
      v-card-text(style="padding: 24px; font-size: 16px; font-weight: 700; text-align:center;")
        | {{ dialogMsg }}
      v-card-actions
        v-spacer
        v-btn(text color="#14C6DE" @click="dialog=false") OK
  v-dialog(v-model="confirmDelete" max-width="420")
    v-card
      v-card-text(style="padding: 24px; font-size: 16px; font-weight: 700; text-align:center;")
        | 確定要刪除嗎？
        div(style="margin-top: 8px; font-size: 13px; font-weight: 500; color: #666;")
          | 此動作無法復原。
      v-card-actions
        v-spacer
        v-btn(text :disabled="deleting" @click="confirmDelete=false") 取消
        v-btn(color="error" depressed :loading="deleting" @click="confirmDeleteYes") 確定
  work-agent-access-dialog(v-if="isAdmin" v-model="accessDialog" entity-type="TEMPLATE" :entity-id="String(selectedId || '')" :entity-name="selectedRow ? selectedRow.agent_name : ''")
</template>

<script>
import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices";
import WorkAgentAccessDialog from "@/components/DocumentAgent/workAgentAccessDialog";

export default {
  name: "ManageWorkAgentDefinition",
  components: {
    WorkAgentAccessDialog,
  },
  data() {
    return {
      loadingList: false,
      saving: false,
      rows: [],
      selectedId: null,
      form: { guid: "", agent_name: "", goal: "", agent_config_text: "" },
      dialog: false,
      dialogMsg: "",
      confirmDelete: false,
      pendingDeleteId: null,
      accessDialog: false,
    };
  },
  computed: {
    isAdmin() {
      return localStorage.getItem('is_staff') === 'true';
    },
    selectedRow() {
      if (!this.selectedId) return null;
      return this.rows.find(r => String(r.id) === String(this.selectedId)) || null;
    },
  },
  created() {
    this.fetchList();
  },
  methods: {
    async fetchList() {
      this.loadingList = true;
      try {
        const { data } = await UpGPTPortalDataServices.getDocumentAgentManageDefinition();
        this.rows = Array.isArray(data) ? data : [];
      } catch (e) {
        this.pop(this.errMsg(e));
      } finally {
        this.loadingList = false;
      }
    },

    selectRow(r) {
      this.selectedId = r.id;
      this.form.guid = String(r.id ?? "");
      this.form.agent_name = r.agent_name ?? "";
      this.form.goal = r.goal ?? "";
      this.form.agent_config_text = this.toText(r.agent_config);
    },

    async onUpdate() {
      this.saving = true;
      try {
        const guid = (this.form.guid || "").trim();
        const payload = {
          agent_name: (this.form.agent_name || "").trim(),
          goal: (this.form.goal || "").trim(),
          agent_config: this.form.agent_config_text?.trim() ? JSON.parse(this.form.agent_config_text) : {}, // textarea 的 String 轉回 [Object]
        };

        if (!guid) {
          const { data } = await UpGPTPortalDataServices.postDocumentAgentManageDefinition(payload);
          if (data?.id != null) {
            this.form.guid = String(data.id);
            this.selectedId = data.id;
          }
          this.pop("新增成功");
        } else {
          await UpGPTPortalDataServices.putDocumentAgentManageDefinition(guid, payload);
          this.selectedId = guid;
          this.pop("更新成功");
        }

        await this.fetchList();
      } catch (e) {
        this.pop(this.errMsg(e));
      } finally {
        this.saving = false;
      }
    },

    onCancelEdit() {          //清空
      this.selectedId = null;
      this.form = { guid: "", agent_name: "", goal: "", agent_config_text: "" };
    },

    onDelete() {
      if (!this.selectedId) return;
        this.pendingDeleteId = this.selectedId;
        this.confirmDelete = true;
    },

    async confirmDeleteYes() {
      if (!this.pendingDeleteId) return;
      this.deleting = true;
      try {
        await UpGPTPortalDataServices.deleteDocumentAgentManageDefinition(this.pendingDeleteId);
        this.pop("刪除成功");
        this.onCancelEdit();
        await this.fetchList();
      } catch (e) {
        this.pop(this.errMsg(e));
      } finally {
        this.deleting = false;
        this.confirmDelete = false;
        this.pendingDeleteId = null;
      }
    },

    toText(v) {   //API 回[Object]，須轉String給textarea顯示
      if (v == null) return "";
      if (typeof v === "string") return v;
      try { return JSON.stringify(v, null, 2); } catch (_) { return String(v); }
    },

    onManageAccess() {
      if (!this.selectedId) return;
      this.accessDialog = true;
    },

    pop(msg) {
      this.dialogMsg = msg || "";
      this.dialog = true;
    },

    errMsg(err) {
      const s = err?.response?.status;
      const d = err?.response?.data;
      if (d) {
        try { return `HTTP ${s}\n` + JSON.stringify(d, null, 2); }
        catch (_) { return `HTTP ${s}\n` + String(d); }
      }
      return err?.message || "Error";
    },
  },
};
</script>

<style scoped>
.table-wrap { font-size: 14px; border: 1px solid #d9d9d9; border-radius: 10px; overflow: auto; max-height: 350px; background: #fff; }
.table { width: 100%; border-collapse: collapse; table-layout: fixed; }
.table th { position: sticky; top: 0; background: #f6f7f9; padding: 10px; border-bottom: 1px solid #e5e5e5; text-align: left; }
.table td { padding: 10px; border-bottom: 1px solid #f0f0f0; }
.table tr { cursor: pointer; }
.table tr.selected td { background: #e9f9fc; }
.guid-col { width: 300px; } 
.name-col { width: 200px; } 
.description-col { width: 300px; } 
.config-col { width: auto; }
.ellipsis { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.form-grid { display: grid; gap: 10px; }
.form-row { font-size: 14px; display: grid; grid-template-columns: 100px 1fr; gap: 12px; align-items: start; }
.label { font-weight: 700; padding-top: 10px; color: #444; }
.v-text-field{ font-size: 14px; }
</style>